/**
 * The home feed's RAW primary source for a card, projected as `source_type` beside the display label
 * since follow-payoff slice 2 (`FP-1b`, 2026-09-13; `DiscussionWithoutContentDTO.getSourceType()` on
 * the server).
 *
 * <p>Hand-written because `sourceType` is not yet in `src/generated-client/api.ts`: the generated
 * client predates the projection. Once the integrator runs `make sync-client-local` the generated
 * `DiscussionWithoutContentDTO` carries the field and this file narrows to a re-export of it; until
 * then the card reads the property through this shape.
 *
 * <p>Only the home feed sets it; every other DTO-producing query leaves it `null`/absent. The one
 * value the client acts on is `FOLLOWED_USERS` (decision A17): the "Because you follow" chip.
 */
export type FeedCardSourceFields = {
    /** `FOLLOWED_USERS`, `MY_GROUPS`, `AFFINITY`, ... or null; see `DiscussionViewSourceDetail` on the server. */
    sourceType?: string | null;
};

export const FOLLOWED_USERS_SOURCE_TYPE = "FOLLOWED_USERS";
